import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/services/user.service';
import { LocalizationService } from 'src/services/localization.service';

@Component({
  standalone: false,
  selector: 'app-project-activities',
  templateUrl: './project-activities.component.html',
  styleUrls: ['./project-activities.component.scss']
})
export class ProjectActivitiesComponent implements OnInit {

  @Input() 
  project : any;

  activitiesUri : string;

  mentionsUri : string;

  constructor(public userService : UserService, public loc : LocalizationService, private router : Router) { }

  ngOnInit(): void {
  }

  navigate(activity : any) {
    if (activity?.Content == 'project_analysis_created')
      this.router.navigate(['/projects', this.project.Id], { queryParams: { view: 'analysis' } });
    else if (activity?.Candidate)
      this.router.navigate(['/projects', this.project.Id, 'candidates', activity.Candidate.Id]);
  }

  ngOnChanges()
  {
    if (!this.project) return;
    this.activitiesUri = `projects/${this.project.Id}/activities`;
    this.mentionsUri = `projects/${this.project.Id}/mentions`;
  }

}
